import React from 'react';
import styled from 'styled-components';
import { Container, Button } from '../../common';

const NavbarPrimaryDesktopCtaButton = ({ sanity }) => {
  const { navbars } = sanity;

  return (
    <Container
      padding="none"
      classes="absolute inset-y-0 right-0 hidden items-center pr-2 sm:static sm:inset-auto sm:pr-0 lg:flex"
    >
      <div className="hidden sm:flex sm:items-center">
        <Button
          linkType="internal"
          internalLink={navbars?.navCtaButtonLink?.slug?.current}
          label={navbars?.navCtaButtonLabel}
          sanity={sanity}
        />
      </div>
    </Container>
  );
};

export { NavbarPrimaryDesktopCtaButton };
